module.exports = __webpack_public_path__ + "media/images/icons/outlined/field-binary-890898a4ccfe3558942c80b8a9c3b456.svg";